export default __webpack_public_path__ + "static/media/house-1.c2ef10b8.jpg";